<nz-divider></nz-divider>

<form nz-form  [formGroup]="actionCommentsGroup">
  <div nz-row>
      
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="mr-md" >
      <nz-form-label>Actions</nz-form-label>
      <nz-form-control>
        <nz-select id="selectedAction" formControlName="selectedAction">
          <nz-option *ngFor="let action of actions" [nzValue]="action" [nzLabel]="action"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="ml-lg">
      <nz-form-label>Comments</nz-form-label>
      <nz-form-control >
        <textarea rows="2" id="comments" formControlName="comments" nz-input></textarea>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <div class="float-right">
      <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
    </div>
  </div>
</div>
</form>